export default __webpack_public_path__ + "static/media/Gioithieu_thumbnail_1.1c23e36e.png";